import { Component, OnInit, Output, EventEmitter, ViewEncapsulation, Input } from '@angular/core';

@Component({
  selector: 'app-sub-list-menu',
  templateUrl: './sub-list-menu.component.html',
  styleUrls: ['./sub-list-menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SubListMenuComponent implements OnInit {
  @Input()
  activeId: number = 1;
  openClose: boolean = true;
  @Output('openOrClose') openOrClose = new EventEmitter();
  @Output('activeList') activeList = new EventEmitter();
  @Input('menuList') menuList;
  constructor() {}

  ngOnInit() {}
  setActive(id) {
    this.activeId = id;
    this.activeList.emit(this.activeId);
  }
  openOrCloseMenu() {
    this.openClose = !this.openClose;
    return this.openOrClose.emit(this.openClose);
  }
}
